'use strict'

import Promise from 'bluebird'
import _ from 'lodash'
import { calcOrderTotals } from './order-totals-util'

export function paymentService (http) {
	const service = {

		// Load payments by user id
		findByUserId: function (userId) {
			return http.jsonrpc(
				'/rpc/2.0/payments',
				'findOrdersByUserId',
				[userId]
			).then(function (resp) {
				return resp.result
			})
		},
		// Load payment by id
		findById: function (orderId) {
			return http.jsonrpc(
				'/rpc/2.0/payments',
				'findOrderById',
				[orderId]
			).then(function (resp) {
				return resp.result
			})
		},
		// Add new payment
		insert: function (data) {
			return http.jsonrpc(
				'/rpc/2.0/payments',
				'insert',
				[data]
			).then(function (resp) {
				return resp.result
			})
		},
		// save payment changes
		update: function (order) {
			return http.jsonrpc(
				'/rpc/2.0/payments',
				'update',
				[order]
			).then(function (resp) {
				return resp.result
			})
		},

		// Load credentials in order to process a payment
		loadCredentials: function () {
			return http.jsonrpc(
				'/rpc/2.0/payment',
				'loadCredentials'
			).then(function (resp) {
				return resp.result
			})
		},

		composePaymentObj: function (card, order, billingAddress) {
			return service.loadCredentials().then(function (credentials) {
				console.debug('Attemping to pay, order', order)
				console.debug('Attemping to pay, billing address', billingAddress)

				const address = billingAddress.contactMethods.addresses[0]
				// E24-32: use the same rounded total every other order-total
				// display in the app uses, rather than a raw, unrounded
				// float sum -- this is the actual amount submitted to the
				// payment gateway as a live charge.
				const total = calcOrderTotals(order.orderSubtotal, order.orderTax).total
				// Compose object
				const body = {
					ssl_merchant_id: credentials.merchantId,
					ssl_user_id: credentials.merchantUserId,
					ssl_pin: credentials.merchantPin,
					ssl_amount: total,
					ssl_card_number: card.cardNumber,
					ssl_exp_date: card.expireMonth + card.expireYear.toString().substring(2, 4),
					ssl_invoice_number: order.orderId,
					ssl_cvv2cvc2_indicator: '1',	// CVV present
					ssl_cvv2cvc2: card.cvv,
					ssl_first_name: billingAddress.name.first,
					ssl_last_name: billingAddress.name.last,
					ssl_avs_address: address.line1,
					ssl_city: address.cityText,
					ssl_state: address.stateText,
					ssl_avs_zip: address.postalCode,
					ssl_result_format: 'ASCII',
					ssl_transaction_type: 'ccsale',
					ssl_show_form: 'false',
					ssl_error_url: credentials.payReceipt,
					ssl_receipt_link_method: 'REDG', // REDG, POST
					ssl_receipt_link_url: credentials.payReceipt,
					ssl_test_mode: credentials.merchantTestMode
				}

				// Convert object to array [ { name:'a', value:'val1'}, ... ]
				// E24-32: `_.mapValues` never coerces its result back to a
				// real array (even given one), so this used to always
				// return a plain object like `{0: {...}, 1: {...}, ...}`
				// despite the comment above -- `_.map` is the array-preserving
				// equivalent.
				const pairs = _.map(Object.entries(body), (pair) => {
					return { name: pair[0], value: pair[1] }
				})
				const out = { action: credentials.payUrl, data: pairs }
				console.log('Collect payment', out)
				return Promise.resolve(out)
			})
		}
	}

	return service
}



// WEBPACK FOOTER //
// ./src/common/e24-services/payment-service.js